import { useFormContext } from './form';
import React, { useEffect, useRef, useState } from 'react';
import Flag from '../../Vessels/Single/Rows/Flag';
import { Checkbox, Chip, IconButton } from 'material-ui';
import ContentAddIcon from 'material-ui/svg-icons/content/add-circle-outline';

const styles = {
    checkbox: {
        marginTop: '30px',
    },
    add: {
        marginTop: '25px',
        display: 'flex',
        justifyContent: 'center',
    },
    chips: {
        margin: '8px 8px 0 0',
    },
};

export function FormSelectFlags() {
    const form = useFormContext();
    const [flag, setFlag] = useState({});
    const [excluded, setExcluded] = useState(false);

    const { flags = [] } = form.values;

    const addFlag = () => {
        if (!flag._id) return flags;

        let newFlags = flags;
        const exists = flags.some(x => x.flag._id === flag._id);
        if (!exists) {
            const newFlag = { flag, excluded };
            newFlags = [...flags, newFlag];
            form.onChange({ field: 'flags', value: newFlags });
        }
        setFlag({});
        setExcluded(false);
        return newFlags;
    };

    // captureSaveHandler doesn't work correctly otherwise
    const addFlagRef = useRef();
    addFlagRef.current = addFlag;

    useEffect(() => {
        form.addSaveHandler((values) => {
            values.flags = addFlagRef.current();
        });
    }, []);

    const deleteFlag = (index) => {
        form.onChange({ field: 'flags', value: flags.filter((_, i) => i !== index) });
    };

    return (
        <React.Fragment>
            <div className='row'>
                <div className='col-xs-8'>
                    <Flag
                        changeAutoComplete={(_, data) => setFlag(data)}
                        flagObject={flag}
                    />
                </div>
                <div className='col-xs-2' style={styles.checkbox}>
                    <Checkbox
                        label="Excluded"
                        checked={excluded}
                        onCheck={() => setExcluded(!excluded)}
                    />
                </div>
                <div className='col-xs-2' style={styles.add}>
                    <IconButton>
                        <ContentAddIcon
                            onClick={addFlag}
                            color='green'
                        />
                    </IconButton>
                </div>
            </div>
            <div className='row'>
                <div
                    className='col-xs-12'
                    style={{
                        display: 'flex',
                        flexFlow: 'wrap',
                    }}
                >
                    {
                        flags && flags.map((f, index) => (
                            <Chip
                                key={index}
                                onRequestDelete={() => deleteFlag(index)}
                                style={{
                                    ...styles.chips,
                                    backgroundColor: f.excluded ? '#e6e6e6' : '#d6edbd',
                                }}
                            >
                                {f.excluded && '- '}{f.flag.name}
                            </Chip>
                        ))
                    }
                </div>
            </div>
        </React.Fragment>
    );
}



// WEBPACK FOOTER //
// ./app/components/common/Form/FormSelectFlags.jsx